module.exports = __webpack_public_path__ + "static/media/aatLogo.3e9adf51.png";